import { staticImplements } from 'utils/types'

import type _AddressManager from "mobx/AddressManager"
import { type AppParams } from 'mobx/Infra/Infra.type'
import type _User from "mobx/User"

import type { AddressManagerV2Dependencies } from './types'
import type LocalizationStore from 'mobx/Localization/store'

@staticImplements<AddressManagerV2Dependencies>()
export default class AddressManagerV2Repository {

    static addressManager: typeof _AddressManager | null = null

    static appParams: AppParams | null = null

    static localizationStore: LocalizationStore | null = null

    static user: typeof _User | null = null

    static newLocalizationFlowEnabled(): boolean {
        return this.appParams?.features?.localizationFlow?.enabled === true
    }

    static setAppParams(appParams: AppParams): void {
		this.appParams = appParams
	}

    static setLocalizationStore(localizationStore: LocalizationStore): void {
		this.localizationStore = localizationStore
	}

    static setAddressManager(addressManagger: typeof _AddressManager): void {

        // New localization Feature Flag is ON, AddressManager is set to null
        if(this.newLocalizationFlowEnabled()) {
            this.addressManager = null
        }

        // New localization Feature Flag is OFF, AddressManager is available
        else {
            this.addressManager = addressManagger
        }

	}

    static setUser(user: typeof _User) {
        this.user = user
    }

    static getStoreId = () => localStorage.getItem('storeId')
}